import $ from "jquery";

export const Login = function () {
	if (!($("#login").length > 0)) return false;

	const $elms = {
		inputPassword: $("#password"),
		submitBtn: $("#login-btn"),
		loginWrapper: $(".login"),
		showPasswordBtn: $(".js-show-password"),
		resetBtn: $(".js-reset-btn"),
	};

	const onReset = function () {
		$elms.inputPassword.val("");

	};


	const onSubmit = function () {
		$elms.submitBtn.addClass("is-loading");

		const userInput = $elms.inputPassword.val().trim();
		const password = window.CFG.login.password;

		if (userInput !== password) {
			$elms.loginWrapper.addClass("is-incorrect");
			$elms.submitBtn.removeClass("is-loading");

			setTimeout(function () {
				$elms.loginWrapper.removeClass("is-incorrect");
				onReset()
			}, 3000);
			return;
		}

		$elms.loginWrapper.addClass("is-correct");
		$elms.submitBtn.addClass("is-correct");
		$elms.submitBtn.removeClass("is-loading");

		const days = 400;
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		const expires = "expires=" + date.toUTCString();
		document.cookie = "bd-session=" + Date.now() + ";" + expires + ";path=/";

		window.location.href = window.CFG.homeURL;
	};

	
	


	$($elms.submitBtn).on("click", function () {
		onSubmit();
	});





	$($elms.inputPassword).on("input", function () {
		const userInput = $elms.inputPassword.val().trim();

		if (userInput.length > 0) {
			$elms.submitBtn.removeAttr("disabled");
		} else {
			$elms.submitBtn.attr("disabled", "disabled");
		}
	});

	$($elms.showPasswordBtn).on("mousedown touchstart", function () {
		$elms.inputPassword.attr("type", "text");
	});

	$($elms.showPasswordBtn).on("mouseup mouseleave touchend", function () {
		$elms.inputPassword.attr("type", "password");
	});
};
